<template>
    <table class="table table-striped">
        <thead>
            <tr>
                <th>{{ $trans.get('__JSON__.Project') }}</th>
                <th>{{ $trans.get('__JSON__.Minimum employees') }}</th>
                <th>{{ $trans.get('__JSON__.Actions') }}</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="projectEmployee in projectEmployees">
                <td>
                    <select class="form-control form-control-sm" v-model="projectEmployee.project_id"
                    style="border-radius: 0.5rem; font-weight: bold" @change="change(projectEmployee)"
                    :style="{
                        background: this.getColor(projectEmployee.project_id),
                        color: hexToLuma(projectEmployee.project_id),
                    }"
                    :class="{ 'border border-danger': projectAlreadyInList( projectEmployee ) }"
                    >
                        <option value="0" selected>{{ $trans.get("__JSON__.Choose project") }}</option>
                        <option v-for="item in projects" :key="item.id" :value="item.id">
                            {{ item.client.name }} - {{ item.name }}
                        </option>
                    </select>
                </td>
                <td>
                    <input type="number" v-model="projectEmployee.employee_count" @keyup="change(projectEmployee)" @change="change(projectEmployee)">
                </td>
                <td><button v-if="projectEmployee.id" class="btn" @click="deleteLine(projectEmployee)"><i class="fa fa-trash"></i></button></td>
            </tr>
        </tbody>
    </table>

    <button v-if="dirty && !doubles" class="btn btn-primary" @click="saveProjectEmployees">{{ $trans.get('__JSON__.Save') }}</button>
    <button class="btn float-right" v-tooltip :title="$trans.get('__JSON__.Add project')" @click="addProjectEmployees"><i
            class="fa fa-plus fa-2x text-primary"></i></button>
</template>

<script>
import axios from "axios";

export default {
    setup() {
    },
    name: "ProjectEmployees",
    created() {
        this.fetchProjects();
        this.fetchProjectEmployees();
    },
    props: {
        team_id: Number,
    },
    watch: {
        projectEmployees: {
            handler(newValue, oldValue) {
                console.log("Watcher!");
            },
            deep: true,
        },
        team_id: function() {
            this.fetchProjects();
            this.fetchProjectEmployees();
        }
    },
    data() {
        return {
            projects: null,
            projectEmployees: [],
            dirty: false,
            doubles: false
        };
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        fetchProjects() {
            axios
                .get("/api/projects/all", {
                    params: {
                        team_id: this.team_id,
                    },
                })
                .then((resp) => {
                    this.projects = resp.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        fetchProjectEmployees() {
            console.log('fetch');
            axios
                .get("/api/projectemployeerequirements", {
                    params: {
                        team_id: this.team_id,
                    },
                })
                .then((resp) => {
                    this.oldProjectEmployees = resp.data;
                    this.projectEmployees = resp.data;
                    this.dirty = false;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        saveProjectEmployees() {
            for (var projectEmployee of this.projectEmployees) {
                this.save(projectEmployee);
            }
        },
        projectAlreadyInList(projectEmployee) {
            const doubleProject = this.projectEmployees.find( (item) => item.project_id == projectEmployee.project_id && item !== projectEmployee);
            if (doubleProject != undefined) {
                this.doubles = true;
            }
            return (doubleProject != undefined);
        },
        async save(projectEmployee) {
            if (projectEmployee.id > 0) {
                axios
                    .put("/api/projectemployeerequirements/" + projectEmployee.id, projectEmployee)
                    .then((resp) => {
                        this.dirty = false;
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } else {
                axios
                    .post("/api/projectemployeerequirements", projectEmployee)
                    .then((resp) => {
                        this.dirty = false;
                        projectEmployee.id = resp.data.id;
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        deleteLine(projectEmployee) {
            if (projectEmployee.id > 0) {
                axios
                    .delete("/api/projectemployeerequirements/" + projectEmployee.id)
                    .then((resp) => {
                        this.dirty = false;
                        this.fetchProjectEmployees();
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        hexToLuma(projectId) {
            //const colour = this.projectColor(projectId);
            const colour = this.rgba2hex(this.getColor(projectId));
            const hex = colour.replace(/#/, "");
            const r = parseInt(hex.substr(0, 2), 16);
            const g = parseInt(hex.substr(2, 2), 16);
            const b = parseInt(hex.substr(4, 2), 16);

            return [0.299 * r, 0.587 * g, 0.114 * b].reduce((a, b) => a + b) / 255 > 0.5
                ? "black"
                : "white";
        },
        rgba2hex(orig) {
            var a,
                isPercent,
                rgb = orig.replace(/\s/g, "").match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i),
                alpha = ((rgb && rgb[4]) || "").trim(),
                hex = rgb
                    ? (rgb[1] | (1 << 8)).toString(16).slice(1) +
                    (rgb[2] | (1 << 8)).toString(16).slice(1) +
                    (rgb[3] | (1 << 8)).toString(16).slice(1)
                    : orig;

            if (alpha !== "") {
                a = alpha;
            } else {
                a = 1;
            }
            // multiply before convert to HEX
            a = ((a * 255) | (1 << 8)).toString(16).slice(1);
            hex = hex + a;

            return hex;
        },
        hexToRgb(hex) {
            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result
                ? {
                    r: parseInt(result[1], 16),
                    g: parseInt(result[2], 16),
                    b: parseInt(result[3], 16),
                }
                : null;
        },
        getColor(projectId) {
            var mycolor = "#ffffff";

            if (this.projects) {
                const project = this.projects.find(
                    (element) => element.id == projectId
                );

                if (project && project.color) {
                    const color = this.hexToRgb(project.color);
                    mycolor =
                        "rgba(" + color.r + ", " + color.g + ", " + color.b + ", " + 0.7 + ")";
                    //            (0.3 + 0.2 * (this.index % 2)) +
                }
            }
            return mycolor;
        },

        addProjectEmployees() {
            $(".tooltip").css('display', 'none');
            this.projectEmployees.push(
                {
                    team_id: this.team_id,
                    project_id: 0,
                    employee_count: 1,
                }
            );
        },
        change(projectEmployee) {
            this.doubles = false;
            this.dirty = true;
            console.log("change", projectEmployee);
        }
    }
};
</script>

<style scoped></style>
